import styles from "./Rack.module.css";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Tile} from "../tile/Tile";
import {OrientedTile} from "../../models/tile";
import {
    boardToRack,
    pickTile,
    Player, RackTileLocation,
    selectBagIsEmpty, selectChosenTileLocation,
    selectRackContents, TileLocation
} from "../game/gameSlice";
import React from "react";
import {useDrop} from "react-dnd";


type PlayableTileProps = {
    tile: OrientedTile,
    isFocussed: boolean,
    isChosen: boolean,
    tileIndex: number,
    player: Player
}

function PlayableTile({tile, isFocussed, isChosen, player, tileIndex}: PlayableTileProps) {
    const tileLocation = {
        kind: "rack",
        player: player,
        index: tileIndex,
    } as RackTileLocation;
    return (
        <div
            className={styles.tilePlace}
        >
            <Tile
                isFocussed={isFocussed}
                isChosen={isChosen}
                tile={tile}
                location={tileLocation}
                rotationTypes={["rotateClockwise", "flipVertical", "flipHorizontal"]}
            />
        </div>
    )
}

export const MAX_TILES_ON_RACK = 10;


type RackProps = {
    player: Player;
};

export function Rack(props: RackProps) {
    const player = props.player;
    const dispatch = useAppDispatch();
    const chosenTileLocation = useAppSelector(selectChosenTileLocation);
    const {tiles, focussedTileIndex, chosenTileIndex} = useAppSelector(selectRackContents)[player];
    const thereAreNoTilesLeft = useAppSelector(selectBagIsEmpty);
    const dispatchBoardToRack = (tileLocation: TileLocation) => {
        if (tileLocation.kind === "board") {
            dispatch(boardToRack({
                boardCol: tileLocation.boardCol,
                boardRow: tileLocation.boardRow,
                player: player,
            }))
        }
    }
    const [_, drop] = useDrop(() => ({
        accept: 'PLACE_TILE',
        drop: (item) => {
            dispatchBoardToRack(item as TileLocation);
        }
    }));
    return (
        <div>
            <button
                className={styles.takeTile}
                disabled={ thereAreNoTilesLeft }
                onClick={() => {dispatch(pickTile(player))}}
            >
                Take tile
            </button>
            <div
                ref={drop}
                className={styles.rack}
                onPointerUp={() => {
                    if (chosenTileLocation) {
                        dispatchBoardToRack(chosenTileLocation);
                    }
                }}
            >
                {
                    tiles.map((tileProps: OrientedTile, tileIndex) => (
                        <PlayableTile
                            key={tileIndex}
                            isFocussed={tileIndex === focussedTileIndex}
                            isChosen={tileIndex === chosenTileIndex}
                            player={player}
                            tileIndex={tileIndex}
                            tile={tileProps}
                        />
                    ))
                }
            </div>
        </div>
    )
}